import { render, staticRenderFns } from "./xiugaiSG.vue?vue&type=template&id=9d4b6a6e&scoped=true&"
import script from "./xiugaiSG.vue?vue&type=script&lang=js&"
export * from "./xiugaiSG.vue?vue&type=script&lang=js&"
import style0 from "./xiugaiSG.vue?vue&type=style&index=0&id=9d4b6a6e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4b6a6e",
  null
  
)

export default component.exports